/**
 * Handle global nav related tasks
 */
class Nav {
	constructor() {
		this.init();
	}

	/**
	 * Set class variables, Add Overlay Element, and Event Handlers
	 */
	init = () => {
		this.body = document.querySelector('body');
		this.navContainer = document.querySelector('#global-nav-container');
		this.overlay = document.querySelector('#global-nav-overlay');
		this.topNav = document.querySelector('#top-nav');
		this.hamburgerMenu = document.querySelector('#offcanvas-menu-btn');
		this.navCheckbox = document.querySelector('#navigation-checkbox');

		this.addOverlayElement();
		this.addHanburgerMenuHandler();
		this.addOverlayHandler();
	};

	/**
	 * Add Overlay element as a child of the body class
	 * TODO: this could be hard coded into the template, but it does need to take the entire body space, perhaps this is better
	 */
	addOverlayElement = () => {
		const div = document.createElement('div');
		div.id = 'global-nav-overlay';
		this.body.appendChild(div);

		this.overlay = document.querySelector('#global-nav-overlay');
	};

	/**
	 * Add Overlay Event Handler
	 */
	addOverlayHandler = () => {
		this.overlay.addEventListener('click', event => this.overlayHandler(event));
	};

	/**
	 * Add Hamburger Menu event Handler
	 */
	addHanburgerMenuHandler = () => {
		this.hamburgerMenu.addEventListener('click', event => this.hamburgerMenuHandler(event));
	};

	/**
	 * Event Handler for Top Nav Hamburger Button
	 * @param event
	 */
	hamburgerMenuHandler = (event) => {
		this.toggleGlobalNav();
	};

	/**
	 * Event Handler for Global Nav Overlay
	 * @param event
	 */
	overlayHandler = (event) => {
		if (this.overlay.classList.contains('global-nav-active')) {
			this.navCheckbox.checked = false;
			this.toggleGlobalNav();
		}
	};

	/**
	 * Hide/Show and translate the navs
	 */
	toggleGlobalNav = () => {
		// Set Global Nav Container height equal to the view port height every time the menu is toggled
		this.navContainer.style.height = `${window.innerHeight}px`;

		// Menu is currently open so close it
		if (this.body.classList.contains('global-nav-active')) {

			// Remove nav translation, active classes, and collapse any open subnav menus
			this.navContainer.style.transform = null;
			this.topNav.style.transform = null;
			this.body.classList.remove('global-nav-active');
			this.overlay.classList.remove('global-nav-active');
			this.collapseSubNav();

		}
		else {

			// Translate the navs down the page, add active classes, and move overlay off of Top Nav
			this.navContainer.style.transform = `translateX(-100%) translateY(${window.pageYOffset}px)`;
			this.topNav.style.transform = `translateY(${window.pageYOffset}px)`;
			this.overlay.style.transform = `translateY(${this.topNav.offsetHeight + window.pageYOffset}px)`;
			this.body.classList.add('global-nav-active');
			this.overlay.classList.add('global-nav-active');
		}
	};

	/**
	 * Collapse any expanded subnav lists
	 */
	collapseSubNav = () => {
		const subNavToggles = document.querySelectorAll('input.nav-item-toggle');

		for (const navToggle of subNavToggles) {
			navToggle.checked = false;
		}
	}
}

export default Nav;
